module.exports = __webpack_public_path__ + "img/san-marino.494ff576.svg";